module.exports = __webpack_public_path__ + "static/media/immaculata_ruiz.5243f915.png";